/* Syrae — drawer panier : rendu depuis /cart.js, +/−, ligne cadeau, Garanzia a Vita, compte à rebours de spedizione. */
(function () {
  'use strict';
  var root = document.getElementById('SyraeCartDrawer');
  if (!root) return;
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var meta = {};
  try { meta = JSON.parse(document.getElementById('SyraeCartMeta').textContent); } catch (e) { meta = { compare: {} }; }
  var fmt = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 2 });
  function money(c) { return fmt.format(c / 100).replace(/ /g, ' '); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }

  var itemsEl = $('[data-drawer-items]'), emptyEl = $('[data-drawer-empty]'), footer = $('[data-drawer-footer]');
  var warrantyBox = $('[data-drawer-warranty]'), toggle = $('[data-warranty-toggle]');
  var busy = false, lastFocus = null;

  /* ---------------------------------------------------------------- ouverture / fermeture */
  function open() {
    lastFocus = document.activeElement;
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.documentElement.classList.add('syrae-drawer-lock');
    var panel = $('.syrae-drawer__panel'); if (panel) panel.focus();
  }
  function close() {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('syrae-drawer-lock');
    setTimeout(function () { if (!root.classList.contains('is-open')) root.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  root.addEventListener('click', function (e) { if (e.target.closest('[data-drawer-close]')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

  // L'icône panier du header ouvre le drawer au lieu de naviguer vers /cart
  document.addEventListener('click', function (e) {
    var a = e.target.closest('#cart-icon-bubble, a[href$="/cart"]');
    if (!a || a.closest('syrae-cart-drawer')) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    refresh().then(open);
  });

  /* ---------------------------------------------------------------- rendu */
  function isWarranty(it) { return meta.warrantyVariant && it.variant_id === meta.warrantyVariant; }

  var XSVG = '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>';
  var TAG = '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path d="M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2.2a2.8 2.8 0 0 0 0 5.6V17a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2.2a2.8 2.8 0 0 0 0-5.6V7z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M14 6.5v11" stroke="currentColor" stroke-width="1.8" stroke-dasharray="2 2.2"/></svg>';

  function line(it) {
    var gift = it.properties && it.properties._Regalo === 'true';
    var cmp = (meta.compare[it.variant_id] || 0) * it.quantity;
    var orig = it.original_line_price;
    var strike = Math.max(cmp, orig);
    var final = it.final_line_price;
    var right = '';
    if (strike > final) {
      right += '<s>' + money(strike) + '</s>';
      if (final === 0) right += '<b class="is-free">Gratis</b>';
      else right += '<span class="syrae-drawer__pct">' + Math.round((1 - final / strike) * 100) + '% di sconto!</span><b><i>' + money(final) + '</i></b>';
    } else right += '<b><i>' + money(final) + '</i></b>';
    var chips = '';
    (it.discounts || []).forEach(function (d) { chips += '<span class="syrae-drawer__chip">' + TAG + esc(d.title) + '</span>'; });
    if (!chips && it.properties && it.properties._Offerta) chips = '<span class="syrae-drawer__chip">' + TAG + esc(it.properties._Offerta) + '</span>';
    var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="syrae-drawer__variant">' + esc(it.variant_title) + '</span>' : '';
    var img = it.image ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')) + '" alt="' + esc(it.featured_image && it.featured_image.alt || '') + '" width="80" height="80">' : '<span class="syrae-drawer__noimg"></span>';
    var dis = gift ? ' disabled' : '';
    return '<div class="syrae-drawer__item' + (gift ? ' is-gift' : '') + '" data-key="' + esc(it.key) + '" data-q="' + it.quantity + '">' +
      '<div class="syrae-drawer__media">' + img + '</div>' +
      '<div class="syrae-drawer__info">' +
        '<button type="button" class="syrae-drawer__remove" data-remove aria-label="Rimuovi"' + dis + '>' + XSVG + '</button>' +
        '<a class="syrae-drawer__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
        '<div class="syrae-drawer__foot">' +
          '<div class="syrae-drawer__qty"><button type="button" data-qty="-1"' + dis + ' aria-label="Diminuisci quantità">-</button><span>' + it.quantity + '</span><button type="button" data-qty="1"' + dis + ' aria-label="Aumenta quantità">+</button></div>' +
          '<div class="syrae-drawer__price">' + right + '</div>' +
        '</div>' +
        (chips ? '<div class="syrae-drawer__chips">' + chips + '</div>' : '') +
      '</div>' +
    '</div>';
  }

  function render(cart) {
    var items = cart.items.filter(function (it) { return !isWarranty(it); });
    var warranty = cart.items.filter(isWarranty)[0];
    var has = cart.items.length > 0;
    itemsEl.innerHTML = items.map(line).join('');
    emptyEl.hidden = has;
    footer.hidden = !has;
    // Garanzia a Vita : interrupteur, la ligne n'est pas listée avec les articles
    if (meta.warrantyVariant) {
      warrantyBox.hidden = !has;
      toggle.checked = !!warranty;
      $('[data-warranty-price]').textContent = money(meta.warrantyPrice);
      var wi = $('[data-warranty-img]'); if (meta.warrantyImage && !wi.src) wi.src = meta.warrantyImage;
    }
    // Totaux : sous-total barré = somme des prix catalogue (compare_at, sinon prix d'origine)
    var catalog = 0;
    cart.items.forEach(function (it) { catalog += Math.max((meta.compare[it.variant_id] || 0) * it.quantity, it.original_line_price); });
    var total = cart.total_price;
    var saved = catalog - total;
    // « Sconti » = remises réelles de lignes : prix d'origine (cadeau : prix catalogue) moins prix final
    var disc = 0;
    cart.items.forEach(function (it) {
      var gift = it.properties && it.properties._Regalo === 'true';
      var base = gift ? Math.max((meta.compare[it.variant_id] || 0) * it.quantity, it.original_line_price) : Math.max((meta.base && meta.base[it.variant_id] || 0) * it.quantity, it.original_line_price);
      disc += Math.max(0, base - it.final_line_price);
    });
    var old = $('[data-subtotal-old]');
    old.hidden = !(saved > 0);
    old.textContent = money(catalog);
    $('[data-subtotal]').textContent = money(total);
    var dRow = $('[data-discount-row]');
    dRow.hidden = !(disc > 0);
    $('[data-discount-value]').textContent = '-' + money(disc);
    $('[data-drawer-checkout]').disabled = !has;
    var count = cart.item_count;
    var cn = $('[data-drawer-count]'); if (cn) cn.textContent = count ? count : '';
    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (n) { n.textContent = count; });
    document.querySelectorAll('.cart-count-bubble').forEach(function (n) { n.hidden = count === 0; });
    document.dispatchEvent(new CustomEvent('syrae:cart-rendered', { detail: cart }));
  }

  /* ---------------------------------------------------------------- réseau */
  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { render(c); return c; });
  }
  function change(key, quantity) {
    if (busy) return Promise.resolve();
    busy = true; root.classList.add('is-busy');
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (c) { render(c); return c; })
      .then(function (c) { cleanup(c); })
      .catch(function () {})
      .then(function () { busy = false; root.classList.remove('is-busy'); });
  }
  // Plus aucun article hors cadeau / garantie : on vide le panier pour ne pas laisser un cadeau seul
  function cleanup(cart) {
    var real = cart.items.filter(function (it) { return !isWarranty(it) && !(it.properties && it.properties._Regalo === 'true'); });
    if (cart.items.length && !real.length) {
      return fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } }).then(function () { return refresh(); });
    }
  }

  itemsEl.addEventListener('click', function (e) {
    var row = e.target.closest('.syrae-drawer__item'); if (!row) return;
    var key = row.getAttribute('data-key'), q = +row.getAttribute('data-q');
    var step = e.target.closest('[data-qty]');
    if (step) { change(key, q + (+step.getAttribute('data-qty'))); return; }
    if (e.target.closest('[data-remove]')) change(key, 0);
  });

  toggle.addEventListener('change', function () {
    if (busy) return;
    busy = true; root.classList.add('is-busy');
    var req = toggle.checked
      ? fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: meta.warrantyVariant, quantity: 1 }] }) })
      : fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: meta.warrantyVariant, quantity: 0 }) });
    req.then(function () { return refresh(); }).catch(function () {}).then(function () { busy = false; root.classList.remove('is-busy'); });
  });

  /* ---------------------------------------------------------------- compte à rebours : temps restant avant l'heure limite d'expédition */
  function tickCutoff() {
    var now = new Date(), cut = new Date(now.getFullYear(), now.getMonth(), now.getDate(), meta.cutoffHour || 16, 0, 0);
    if (now >= cut) cut.setDate(cut.getDate() + 1);
    var left = Math.floor((cut - now) / 60000);
    var out = $('[data-drawer-cutoff]');
    if (out) out.textContent = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
  }
  tickCutoff(); setInterval(tickCutoff, 30000);

  // Date de livraison estimée (même logique que la fiche produit)
  var del = $('[data-delivery]');
  if (del && window.Syrae) {
    var d = window.Syrae.deliveryDate(+del.getAttribute('data-min') || 5);
    var t = $('[data-delivery-text]', del);
    if (t) t.textContent = window.Syrae.DAYS[d.getDay()].toLowerCase() + ' ' + d.getDate() + ' ' + window.Syrae.MONTHS_LONG[d.getMonth()];
  }

  /* ---------------------------------------------------------------- événements externes */
  document.addEventListener('syrae:cart-updated', function (e) {
    refresh().then(function () { if (e.detail && e.detail.open) open(); });
  });
  window.SyraeCart = { open: open, close: close, refresh: refresh };
  refresh();
})();
